import { useContext } from 'react';
import { NavMeshGeneratorContext } from './NavMeshGeneratorContext';

export const useNavMeshContext = () => {
  const ctx = useContext(NavMeshGeneratorContext);
  if (!ctx) {
    throw new Error('useNavMesh must be used within a NavMeshProvider');
  }

  return ctx;
};
